import type { ReactNode } from 'react';

type Props = {
  text: string;
  children?: ReactNode;
};

export const InfoTooltip = ({ text, children }: Props) => (
  <span className="info-tooltip" aria-label={text}>
    <span aria-hidden="true">{children ?? 'ⓘ'}</span>
    <span className="tooltip-text" role="tooltip">{text}</span>
  </span>
);
